import { DashboardHomeSkeleton } from "@dashboard/components/home/DashboardHomeSkeleton"
import { createFileRoute } from "@tanstack/react-router"
import { lazy, Suspense } from "react"

const DashboardHomePage = lazy(() =>
  import("@dashboard/components/home").then((module) => ({ default: module.DashboardHomePage }))
)

export const Route = createFileRoute("/dashboard/")({
  component: DashboardIndexRoute,
})

function DashboardIndexRoute() {
  return (
    /*
     * A home-shaped placeholder, not the CMS shell. The shell skeleton draws a
     * sidebar rail, a top bar and table rows, none of which the home page has —
     * so signing in showed one layout and then replaced it wholesale, reading
     * as two loads rather than one page arriving.
     */
    <Suspense fallback={<DashboardHomeSkeleton />}>
      <DashboardHomePage />
    </Suspense>
  )
}
